export default __webpack_public_path__ + "static/media/11.e27dc6c9.png";